var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isHidden
    ? _c(
        "collapsible-block",
        {
          ref: "collapsible",
          staticClass: "business-order-view-modal__shipping-documents",
          attrs: {
            "title-text": _vm.fileUploadTitle,
            disabled: !_vm.isEdit && !_vm.isPreview,
            collapsed: !_vm.isEdit && !_vm.isPreview
          }
        },
        [
          !_vm.isPreview
            ? _c(
                "flex-row",
                {
                  staticClass: "flex--no-wrap",
                  attrs: { "column-spacing": "lg" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "business-order-view-modal__upload-description"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.fileUploadDescription) +
                          "\n        "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _c(
            "flex-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.documents.length > 0,
                  expression: "documents.length > 0"
                }
              ],
              staticClass: "business-order-view-modal__shipping-documents-row",
              attrs: { "column-spacing": "lg" }
            },
            _vm._l(_vm.documents, function(document, index) {
              return _c("business-orders-file", {
                key: index,
                attrs: {
                  "file-title": document.fileName,
                  "is-preview": _vm.isPreview,
                  "order-id": _vm.orderId,
                  "document-id": document.documentId
                },
                on: { removed: _vm.handleDocumentRemove }
              })
            }),
            1
          ),
          _vm.$hasAccess("businessorders:write")
            ? _c(
                "flex-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.showDocumentUpload &&
                        !_vm.isPreview &&
                        !_vm.fileLimitReached,
                      expression:
                        "!showDocumentUpload && !isPreview && !fileLimitReached"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "col col--on-left" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass:
                            "business-order-view-modal__shipping-document-action",
                          attrs: { "as-link": "" },
                          on: { click: _vm.toggleDocumentUploadVisibility }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                slot: "iconLeft",
                                width: "20",
                                height: "20"
                              },
                              slot: "iconLeft"
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#plus-round" }
                              })
                            ]
                          ),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "businessOrders.labels.addAdditionalDocument"
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.$hasAccess("businessorders:write")
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDocumentUpload,
                      expression: "showDocumentUpload"
                    }
                  ]
                },
                [
                  _c(
                    "flex-row",
                    {
                      staticClass: "flex--no-wrap flex--justify-center",
                      attrs: { "column-spacing": "lg" }
                    },
                    [
                      _c("drop-zone", {
                        ref: "dropzone",
                        attrs: {
                          "dropzone-options": _vm.documentDropzoneOptions,
                          "placeholder-title": _vm.$t(
                            "businessOrders.labels.dropPdf"
                          )
                        },
                        on: {
                          "file-added": _vm.handleFileAdded,
                          error: _vm.handleDropzoneErrors,
                          canceled: _vm.handleDropzoneFileCancelation,
                          sending: _vm.handleSendingDocuments,
                          success: _vm.handleSucceededDocuments,
                          duplicate: _vm.handleDuplicateDocument,
                          "max-files-reached": _vm.handleMaxFilesReached
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }